<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <window :showHeader="false">
          <p>See documentation
            <a href="https://github.com/xaksis/vue-good-table" target="_blank">here</a>
          </p>
        </window>
      </div>
      <div class="column is-half">
        <window title="Basic">
          <vue-good-table :columns='columns' :rows='rows' :search-options='searchOptions'
          :pagination-options='paginationOptions' styleClass='vgt-table striped bordered' />
        </window>
      </div>
      <div class="column is-half">
        <window title="Dark theme">
          <vue-good-table :columns='columns' :rows='rows' :search-options='searchOptions'
          :pagination-options='paginationOptions' theme="nocturnal" />
        </window>
      </div>
      <div class="column is-half">
        <window title="Sort">
          <vue-good-table :columns='columns' :rows='rows' :search-options='searchOptions'
          :pagination-options='paginationOptions' :sort-options='sortOptions' />
        </window>
      </div>
      <div class="column is-half">
        <window title="Checked">
          <vue-good-table @on-select-all='selectAll' @on-row-click='toggleSelectRow'
          :columns='columns' :rows='rows' :select-options='{ enabled: true }'
          :search-options='{ enabled: true }' styleClass="vgt-table bordered striped">
          </vue-good-table>
        </window>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import VueGoodTable from 'vue-good-table';
// import the styles
import 'vue-good-table/dist/vue-good-table.css';

Vue.use(VueGoodTable);

export default {
  name: 'my-component',
  data() {
    return {
      columns: [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Age',
          field: 'age',
          type: 'number',
        },
        {
          label: 'Created On',
          field: 'createdAt',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'MMM Do YY',
        },
        {
          label: 'Percent',
          field: 'score',
          type: 'percentage',
        },
      ],
      rows: [
        {
          id: 1, name: 'John', age: 20, createdAt: '201-10-31:9: 35 am', score: 0.03343,
        },
        {
          id: 2, name: 'Jane', age: 24, createdAt: '2011-10-31', score: 0.03343,
        },
        {
          id: 3, name: 'Susan', age: 16, createdAt: '2011-10-30', score: 0.03343,
        },
        {
          id: 4, name: 'Chris', age: 55, createdAt: '2011-10-11', score: 0.03343,
        },
        {
          id: 5, name: 'Dan', age: 40, createdAt: '2011-10-21', score: 0.03343,
        },
        {
          id: 6, name: 'John', age: 20, createdAt: '2011-10-31', score: 0.03343,
        },
        {
          id: 7, name: 'Jane', age: 24, createdAt: '20111031',
        },
        {
          id: 8, name: 'Susan', age: 16, createdAt: '2013-10-31', score: 0.03343,
        },
      ],
      searchOptions:
      {
        enabled: true,
      },
      paginationOptions: {
        enabled: true,
        perPage: 5,
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'name', type: 'asc' },
      },
    };
  },
  methods: {
    // selectAll(selected, selectedRows) {
    selectAll() {
      // do what you want here
      // console.log(selected, selectedRows)
    },
    // toggleSelectRow (params) {
    toggleSelectRow() {
      // row that was clicked
      // console.log(params.row)
      // index of page
      // console.log(params.pageIndex)
      // whether the row was selected or unselected
      // console.log(params.selected)
    },
  },
};
</script>
